<template>
    <div>
        <v-card class="ma-2 pa-4">
            <v-card-title>Form navigation</v-card-title>
            <v-card-text class="body-1">
                <p>
                    The side-bar menu displays a list of forms which are due for your completion.
                    <br />Click the menu icon to open the left side-bar.
                    <br />Click on each form to display and start form completion.
                    <br />Click 'Next' to proceed to next screen.
                    <br />Click 'Previous' to go back to previous screen.
                    <br />Once you have completed all the questions, please click 'Submit'.
                </p>
            </v-card-text>
        </v-card>
        <v-card class="ma-2 pa-4">
            <v-img max-width="500"
                   class="white--text align-end mx-auto"
                   :src="require('@/assets/TrialLogo.png')"></v-img>

            <v-card-text class="body-1">
                <v-container>
                    <v-row>
                        <v-col cols="12" md="8" offset-md="2">
                            <!--Home.vue-TrialDesc BEGIN-->
<p>After a stroke, some people have long-term health problems that can greatly affect their quality of life.</p><p>Our aim is to run a research study in the UK to test if an online programme, can improve quality of life for people with long-term mild to moderate physical and/or mental health disability after stroke. We want to find out if this rehabilitation programme is better than usual care.</p><p>If you have any questions about the study, please call the ReSTORe team on 02476 575 767 or email us at <a href="mailto:restore@warwick.ac.uk">restore@warwick.ac.uk</a>.</p><p>If you select email as the best way to contact you, please check your spam/junk folder if you have not received a message.</p>
<!--Home.vue-TrialDesc END-->
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
    export default {
        mounted() {
            this.$store.commit("setCrfTitle", null);
        },
    };
</script>
